import './LoadingScreen.css'

export default function LoadingScreen({ overlay }) {
  return (
    <div className={`loading-screen${overlay ? ' loading-screen-overlay' : ''}`}>
      <div className="loading-spinner"></div>
      <p className="loading-text">Loading...</p>
    </div>
  )
}
